export default __webpack_public_path__ + "static/solucion_1-0b98623a209084d1e9f680ab5007c036.jpg";